import { useState } from 'preact/hooks';
import { ApiError } from '../api.js';
import { t } from '../i18n/index.js';
import { refillCoins, useCoins } from '../coins.js';
import { CoinIcon } from './CoinIcon.js';
import type { CoinKind } from '../../shared/coins.js';

const KIND: Record<CoinKind, string> = {
  start: 'Aloitussaldo',
  refill: 'Päivän täydennys',
  admin: 'Ylläpito',
  bet: 'Panos',
  win: 'Voitto',
  refund: 'Palautus',
  reward: 'Palkkio',
};

/** AreCoin on the account page (2026-10-01): the balance, the daily top-up and the latest events. */
export function CoinsCard() {
  const coins = useCoins(true);
  const [message, setMessage] = useState<{ ok: boolean; text: string } | null>(null);
  if (!coins) return null;
  const refill = async () => {
    try {
      await refillCoins();
      setMessage({ ok: true, text: `Saldo täydennetty ${coins.refillTo.toLocaleString('fi-FI')} AreCoiniin.` });
    } catch (err) {
      setMessage({ ok: false, text: t.errors[err instanceof ApiError ? err.code : 'network'] });
    }
  };
  return (
    <section class="card coins-card">
      <h2>AreCoin</h2>
      <div class="coins-balance">
        <CoinIcon size={56} />
        <div>
          <div class="coins-amount">{coins.balance.toLocaleString('fi-FI')}</div>
          <div class="hint">Areenan leikkivaluutta – ei rahallista arvoa, ei osteta eikä vaihdeta.</div>
        </div>
      </div>
      {coins.canRefill ? (
        <button class="btn btn-primary" onClick={() => void refill()}>
          Täydennä {coins.refillTo.toLocaleString('fi-FI')} AreCoiniin
        </button>
      ) : (
        <p class="hint">
          Kun saldo on alle {coins.refillTo.toLocaleString('fi-FI')}, sen voi täydentää kerran päivässä {coins.refillTo.toLocaleString('fi-FI')} AreCoiniin.
        </p>
      )}
      {message && <p class={message.ok ? 'success' : 'error'}>{message.text}</p>}
      {coins.history.length > 0 && (
        <details>
          <summary>Viimeisimmät tapahtumat</summary>
          <table class="coins-history">
            <tbody>
              {coins.history.map((h) => (
                <tr key={h.id}>
                  <td>{new Date(h.createdAt).toLocaleString('fi-FI', { dateStyle: 'short', timeStyle: 'short' })}</td>
                  <td>
                    {KIND[h.kind] ?? h.kind}
                    {h.reason && h.reason !== KIND[h.kind] ? ` – ${h.reason}` : ''}
                  </td>
                  <td class={h.amount > 0 ? 'plus' : 'minus'}>{(h.amount > 0 ? '+' : '') + h.amount.toLocaleString('fi-FI')}</td>
                  <td class="muted">{h.balanceAfter.toLocaleString('fi-FI')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
    </section>
  );
}
